import { useAuth } from '../contexts/AuthContext';

/**
 * Whether the current user's company has the points/rewards system turned on.
 * Defaults to true when unset — mirrors the backend's default in
 * packages/backend/src/utils/company.ts.
 */
export function usePointsEnabled(): boolean {
  const { user } = useAuth();
  return user?.companySettings?.pointsEnabled ?? true;
}
